var map = {
	".": 72812,
	"./": 72812,
	"./App": 2516,
	"./App.css": 44050,
	"./App.js": 2516,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./assets/image1.jpg": 9928,
	"./assets/image2.jpg": 43236,
	"./assets/image3.jpg": 49690,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./stagekred-logo.svg": 62050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81407;